module.exports = __webpack_public_path__ + "img/icon1.38331d47.png";